import React, { useContext } from 'react';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Tooltip from 'rc-tooltip';

import { NavigationContext } from 'buyside/components/presentation/MainSiteLayout/mainSiteLayout';
import SideNavigationDropdownItem from 'buyside/components/presentation/MainSiteNavigation/SideNavigation/SideNavigationDropdown/sideNavigationDropdownItem';

import useDropdownButton from 'buyside/util/hooks/useDropdownButton';

import styles from './sideNavigationDropdownStyles.scss';

export type DropdownItem = {
  analyticsTag: string;
  disabled?: boolean;
  icon: React.SVGFactory;
  name: string;
  url: string;
};

const SideNavigationDropdown: React.FC<{
  active: boolean;
  analyticsTag?: string;
  dropdownItems: DropdownItem[];
  hasNewLabel?: boolean;
  joyrideTarget?: string;
  name: string;
}> = ({ active, analyticsTag, dropdownItems, hasNewLabel, joyrideTarget, name }) => {
  const { sideNavigationOpen } = useContext(NavigationContext) || {};

  const { dropdownRef, dropdownVisible, toggleDropdown } = useDropdownButton(active);

  const Icon = dropdownItems[0].icon;
  const SecondIcon = dropdownItems[1]?.icon;

  return (
    <div
      ref={dropdownRef}
      className={classNames(styles.navigationDropdown, {
        [styles.active]: active,
        [styles.sideNavigationOpen]: sideNavigationOpen
      })}
      data-joyride-target={joyrideTarget}
    >
      {sideNavigationOpen ? (
        <>
          <button
            className={styles.navigationDropdownName}
            data-heap={analyticsTag}
            onClick={toggleDropdown}
          >
            <div>
              {name}
              {hasNewLabel && <span className={styles.newLabel}>NEW</span>}
            </div>
            <FontAwesomeIcon icon={dropdownVisible ? faChevronUp : faChevronDown} />
          </button>
          <div
            className={classNames(styles.navigationItemDropdownWrapper, {
              [styles.visible]: dropdownVisible
            })}
          >
            <div
              className={classNames(styles.navigationItemDropdown, {
                [styles.sideNavigationOpen]: sideNavigationOpen
              })}
            >
              {dropdownItems.map(dropdownItem => (
                <SideNavigationDropdownItem key={dropdownItem.name} dropdownItem={dropdownItem} />
              ))}
            </div>
          </div>
        </>
      ) : (
        <Tooltip
          trigger={['hover', 'click']}
          placement="right"
          overlay={
            <div className={styles.navigationDropdownTooltip}>
              <span className={styles.navigationDropdownTooltipName}>
                <strong>{name}</strong>
              </span>
              <ul className={styles.collapsedDropdownItems}>
                {dropdownItems.map(dropdownItem => (
                  <SideNavigationDropdownItem key={dropdownItem.name} dropdownItem={dropdownItem} />
                ))}
              </ul>
            </div>
          }
        >
          <button className={styles.navigationDropdownName} data-heap={analyticsTag}>
            <Icon />
            {SecondIcon ? <SecondIcon /> : null}
          </button>
        </Tooltip>
      )}
    </div>
  );
};

export default SideNavigationDropdown;
